import React from 'react';
import './TermsPage.scss'; // Import the SCSS file
import LogoImg from "../../../assets/images/smallLogo.svg";

const TermsPage = () => {
  return (
    <div className="terms-page-container">
       <div className="privacy-center">
         <img
                  src={LogoImg}
                  alt="Logo"
                  className="logo"
                  height={150}
                  width={150}
                />
      <h1 className="page-title">Terms of Service</h1>
      <p className="last-updated">Last Updated: March 2025</p>
      </div>

      <section className="section">
        <h2 className="section-title">How Cultivate Was Born: An Idea That Transforms Lives</h2>
        <p>
          It all began with an idea and a shared dream. Gonzalo and Fernando had always felt that
          entrepreneurial spark, that passion to create something bigger than themselves. From the
          beginning, it was clear that they wanted to build a technology startup capable of
          significantly impacting and transforming lives.
        </p>
        <p>
          The idea for Cultivate was born from a need they both identified around them: the lack of
          access to educational, motivating, and transformative content that would help people grow
          personally and professionally. But it wasn't just about teaching or informing; they sought
          to awaken a lost or yet-to-be-discovered love: reading as a vehicle for change and
          development.
        </p>
        <p>
          They knew that it wasn't enough to create a product. They had to build an experience.
          That's why Cultivate is not just a platform; it's a companion on the journey toward growth.
          Every detail was designed to educate, motivate, and inspire. Each selected podcast and
          each topic covered has a clear purpose: to empower young people and professionals through
          knowledge and promote reading in a digital age.
        </p>
        <p>
          Cultivate is much more than a startup; It's their way of contributing to a better world.
          Gonzalo and Fernando firmly believe that knowledge has the power to transform, and that
          the first step to changing a life can begin with a book, an audio recording, or an
          inspiring idea. In the end, it's not just about what they offer, but about the experience
          they create and the impact they generate.
        </p>
        <p>
          Today, Cultivate reflects the vision of its founders: to be a tool that connects people
          with their personal and professional development, while fostering a community that
          believes in the power of learning to grow.
        </p>
        <p className="call-to-action">
          <strong>Are you ready to be part of this transformation?</strong>
        </p>
      </section>

      {/* You can add more sections for specific terms and conditions here */}
      <section className="section">
        <h2 className="section-title">1. Acceptance of Terms</h2>
        <p>
          By accessing or using Cultivate, you agree to be bound by these Terms of Service and our
          Privacy Policy. If you do not agree to all of the terms and conditions, do not access or
          use the Service.
        </p>
      </section>

      <section className="section">
        <h2 className="section-title">2. Use of the Service</h2>
        <p>
          Cultivate provides educational and motivational content. You may use the Service for your
          personal and professional development in accordance with these Terms.
        </p>
        {/* Add more specific terms related to usage */}
      </section>

      {/* ... more sections for content, intellectual property, limitations, etc. ... */}

      <section className="section">
        <h2 className="section-title">Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us at{' '}
          <a href="mailto:support@cultivateapp.ai" className="contact-link">support@cultivateapp.ai</a>.
        </p>
      </section>
    </div>
  );
};

export default TermsPage;